import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { useCallback } from "react";
import { SelectChipOptionContainer } from "~/components/Select/components/SelectChipOptionContainer";
import { Select } from "~/components/Select/Select";
import { SINGLE_SELECT_OPTION, SINGLE_SELECT_VALUE } from "~/constants/testIDs";
export const SingleSelect = (param)=>{
    let { selectedOption, ...props } = param;
    const listItemRenderer = useCallback((chip)=>{
        const isSelected = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === chip.value;
        return /*#__PURE__*/ _jsx(SelectChipOptionContainer, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-1",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        "data-testid": "".concat(SINGLE_SELECT_OPTION, "-").concat(chip.value),
                        className: "flex-1 p-1 text-14",
                        children: chip.label
                    }, chip.value),
                    isSelected && /*#__PURE__*/ _jsx(Check, {
                        width: 14
                    })
                ]
            })
        });
    }, [
        selectedOption
    ]);
    const chipRenderer = useCallback((chip)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "flex w-full justify-between px-1.5 py-1",
            children: /*#__PURE__*/ _jsx("div", {
                className: "truncate text-14 text-grey-11",
                "data-testid": SINGLE_SELECT_VALUE,
                children: chip.label
            })
        });
    }, []);
    return /*#__PURE__*/ _jsx(Select, {
        isSearchable: false,
        isSingleSelect: true,
        renderAsInput: true,
        showTriangle: true,
        closeMenuOnSelect: true,
        chipRenderer: chipRenderer,
        listItemRenderer: listItemRenderer,
        filterFunc: (items)=>items,
        selectedOptions: selectedOption ? [
            selectedOption
        ] : [],
        ...props
    });
};
